//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        headline: {
            type: String,
            required: true
        },
        action: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            required: true
        },
        helpText: {
            type: String,
            required: false,
            default: ''
        }
    },

    data () {
        return {
            uploading: false,
            uploadButtonDisabled: true,
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        };
    },

    methods: {
        submitUpload () {
            this.uploading = true;
            this.$refs.upload.submit();
        },

        uploadSuccess (response, file, fileList) {
            this.$message({
                type: 'success',
                message: response.message
            });

            this.$refs.upload.clearFiles();
            this.uploading = false;
        },

        uploadError () {
            this.$message({
                type: 'error',
                message: 'Beim Import ist leider ein Fehler aufgetreten, bitte überprüfen Sie die importierte Datei.'
            });

            this.$refs.upload.clearFiles();
            this.uploading = false;
        },

        fileAdded () {
            this.uploadButtonDisabled = false;
        },

        fileRemoved () {
            this.uploadButtonDisabled = true;
        }
    }
};
